import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Result from '../Components/Capillary/Result';
import Progress from '../Components/Capillary/Progress';
import { BaseURL } from '../config/axios';

const questions = {
  1: 'برای شروع از بین تصاویر زیر یکی را انتخاب کنید',
  2: 'انتخابتون عالی بود، کدوم طیف رنگی رو می‌پسندین؟',
  3: 'کدام یک از آثار زیر براتون جذابه؟',
  4: 'محیطی که می‌خواین تابلو رو نصب کنین کجاست؟',
  5: 'بسیار عالی، لطفا با دقت به این چهار اثر نگاه کنین! کدام سبک رو انتخاب میکنین؟',
  6: 'برای دیدن نتیجه ایمیلتون رو وارد کنین'
}

const CapillaryGuidance = () => {
  const [data, setData] = useState()
  const [currentLevel, setCurrentLevel] = useState(1);
  const [selections, setSelections] = useState([]);
  const [email, setEmail] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true)
  const [loading2, setLoading2] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchPainting = async () => {
      await axios.get('/capillary-search')
        .then(res => {
          setData(res.data.data)
        })
        .catch(err => setError(err.response?.data.message || "مشکل در بارگزاری اطلاعات"))
        .finally(() => setLoading(false))
    };

    fetchPainting();
  }, []);


  if (loading) {
    return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;
  }

  if (error) {
    return <div className="centerOfParent h-screen w-full">{error}</div>;
  }

  if (!data) {
    return <div className="centerOfParent h-screen w-full">اطلاعات پیدا نشد</div>;
  }

  const handleSelect = async (id) => {
    const newSelections = [...selections];
    newSelections[currentLevel - 1] = id; // Store selection for current level
    setSelections(newSelections);
    setCurrentLevel((prev) => prev + 1);
  };

  const handleBack = () => {
    if (currentLevel > 1) {
      const updatedSelections = [...selections];
      updatedSelections[currentLevel - 1] = undefined; // Clear selection for current level
      setSelections(updatedSelections);
      setCurrentLevel((prev) => prev - 1);
    }
  };

  const handleRestart = () => {
    setCurrentLevel(1);
    setSelections([]);
    setEmail("");
    setResult(null);
  };

  const renderAnswers = () => {
    if (currentLevel <= 5) {
      return (
        <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-2 mt-6">
          {data[currentLevel].map((item) => (
            <div
              key={item.id}
              className={`relative max-h-48 w-full bg-[#d8d8d8] rounded-lg duration-300 hover:scale-105 overflow-hidden cursor-pointer ${selections[currentLevel - 1] === item.id
                ? "border-primary"
                : "border-gray-300"
                }`}
              onClick={() => handleSelect(item.id)}
            >
              <img width={100} height={100}
                src={BaseURL + item.image?.path}
                alt={`Option ${item.id}`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>)
    }
    if (currentLevel === 6) {
      return (
        <div className="mt-6 mx-auto">
          <input
            type="email"
            placeholder="ایمیل خود را وارد کنید"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      )
    }
  }

  const handleResult = async () => {
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email.toLowerCase().match(re)) {
      alert('ایمیل را به درستی وارد کنید')
      return
    }
    setLoading2(true)
    await axios
      .post("/capillary-search/getPaintingsByTags", { capillarySearchIds: selections, email })
      .then(res => {
        const { data } = res.data
        setResult(data.data)
      })
      .finally(() => setLoading2(false))
  }

  return (
    <div className="container p-6 bg-white shadow-lg rounded-lg my-10" dir='rtl'>
      {!result && <Progress active={currentLevel} />}
      {!result
        ? <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold text-center text-gray-600">
            {questions[currentLevel]}
          </h2>
          {renderAnswers()}
          <div className="flex items-center justify-center gap-4 mt-6">
            {currentLevel > 1 && (
              <button
                onClick={handleBack}
                className="w-fit mt-6 px-4 py-2 bg-gray-600 text-white rounded-md transition duration-200"
              >
                بازگشت
              </button>
            )}
            {currentLevel === 6 && (
              <button
                onClick={handleResult}
                className="w-fit mt-6 px-4 py-2 bg-primary text-white rounded-md transition duration-200"
              >
                {loading2 ? 'درحال جستجو نتایج ...' : 'نمایش نتیجه'}
              </button>
            )}
          </div>
        </div>
        : <button
          onClick={handleRestart}
          className="w-fit mt-6 px-4 py-2 bg-primary text-white rounded-md transition duration-200"
        >
          شروع مجدد
        </button>}
      <div className="flex flex-col gap-4">
        <Result result={result} />
      </div>
    </div>
  );
};

export default CapillaryGuidance;